import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import { tabBar } from '@/pages.json'
import { navigateTo } from '@/utils/navigator'
const tabbarList = tabBar.list.map((item) => ({ ...item, path: `/${item.pagePath}` }))

export const useTabbarStore = defineStore(
  'tabbar',
  () => {
    const currIndex = ref<number>(0)

    // 根据路径设置当前索引
    const setIndexByPath = (path: string) => {
      const index = tabbarList.findIndex((item) => item.path === path)
      if (index !== -1) {
        currIndex.value = index
      }
    }

    const setCurrIndex = (val: number) => {
      // if (val === 2 && currIndex.value === 2) {
      //   navigateTo({
      //     url: '/pages/wallet/wallet',
      //   })
      //   return
      // }
      currIndex.value = val
    }
    watch(
      () => currIndex.value,
      (val) => {
        uni.setStorageSync('app-tabbar-index', val)
        // if (val === 2) {
        //   navigateTo({
        //     url: '/pages/wallet/wallet',
        //   })
        //   return
        // }
        uni.switchTab({ url: tabbarList[val].path })
      },
    )

    const clearCurrIndex = () => {
      currIndex.value = 0
    }
    // 一般没有reset需求，不需要的可以删除
    const reset = () => {
      currIndex.value = 0
    }

    // 初始化时设置当前路径对应的索引
    const initCurrentPath = () => {
      const pages = getCurrentPages()
      if (pages.length > 0) {
        const currentPage = pages[pages.length - 1]
        const currentPath = `/${currentPage.route}`
        setIndexByPath(currentPath)
      }
    }

    return {
      currIndex,
      tabbarList,
      setCurrIndex,
      clearCurrIndex,
      reset,
      setIndexByPath,
      initCurrentPath,
    }
  },
  {
    persist: true,
  },
)
